import { TrashIcon } from "@heroicons/react/24/outline";
import { ReactNode } from "react";
import { FieldArray } from "react-final-form-arrays";
import Button from "../Button/Button";

type RepeatableFieldArrayProps = {
  name: string;
  title?: string;
  addLabel: string;
  emptyItem: any;
  renderItem: (name: string, index: number, remove: () => void) => ReactNode;
  minItems?: number;
  maxItems?: number;
};

function RepeatableFieldArray({
  name,
  title,
  addLabel,
  emptyItem,
  renderItem,
  minItems = 0,
  maxItems,
}: RepeatableFieldArrayProps) {
  return (
    <FieldArray name={name}>
      {({ fields }) => (
        <div className="flex flex-col w-full flex-1">
          {title && <div className="field-title mb-1">{title}</div>}

          <div className="flex flex-col gap-3">
            {fields.map((fieldName, index) => (
              <div
                key={fieldName}
                className="flex gap-2 items-start p-3 border border-slate-200 rounded-lg bg-slate-50"
              >
                <div className="flex-1">
                  {renderItem(fieldName, index, () => fields.remove(index))}
                </div>
                {fields && (fields?.length ?? 0) > minItems && (
                  <button
                    type="button"
                    onClick={() => fields.remove(index)}
                    className="flex-shrink-0 p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition-colors"
                    aria-label="Supprimer"
                  >
                    <TrashIcon className="w-5 h-5" />
                  </button>
                )}
              </div>
            ))}
          </div>

          {(!maxItems || (fields.length ?? 0) < maxItems) && (
            <div className="mt-2">
              <Button
                type="primary"
                title={addLabel}
                icon="PlusCircleIcon"
                onClick={() => fields.push(emptyItem)}
              />
            </div>
          )}
        </div>
      )}
    </FieldArray>
  );
}

export default RepeatableFieldArray;
